export * from '@dynatrace/strato-components/content';
